module.exports = __webpack_public_path__ + "img/1560902022.2f132dae.jpg";